export * from './instrument-pill.module';
export * from './instrument-pill.service';
export * from './instrument-pill.component';
